import { apiFetch } from "./client";

export interface SubmitWeeklyPayload {
  energy: number;
  stress: number;
  emotionalState: string;
  text?: string;
}

export interface DashboardResponse {
  avgEnergy: number;
  avgStress: number;
  previousWeekAvgEnergy: number;
  previousWeekAvgStress: number;
  emotionalDistribution: Record<string, number>;
  participationRate: number;
  insight: {
    burnoutRiskLevel: string;
    keyShifts: string[];
    recurringThemes: string[];
    executiveSummary: string;
    leadershipConsideration: string;
  };
}

export function submitDaily(slug: string, energy: number): Promise<{ success: boolean }> {
  return apiFetch<{ success: boolean }>(`teams/${encodeURIComponent(slug)}/daily`, {
    method: "POST",
    body: JSON.stringify({ energy }),
  });
}

export function submitWeekly(
  slug: string,
  payload: SubmitWeeklyPayload
): Promise<{ success: boolean }> {
  return apiFetch<{ success: boolean }>(`teams/${encodeURIComponent(slug)}/weekly`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchDashboard(
  slug: string,
  adminKey: string
): Promise<DashboardResponse> {
  return apiFetch<DashboardResponse>(`teams/${encodeURIComponent(slug)}/dashboard`, {
    method: "GET",
    headers: {
      "x-admin-key": adminKey,
    },
  });
}
